// @generated source--
// scripts/generate-bits/file-generators/component-story-map.generator.ts

export const patternStoryMap: {
  [name: string]: {
    path: string;
    tags: string[];
    internalOnly: boolean;
    stories: string[];
    description: string;
  };
} = {
  'accept-rate': {
    path: '',
    tags: ['reputation'],
    internalOnly: true,
    stories: ['default', 'compact', 'size'],
    description:
      "Shows a user's accept rate as a percentage and a progress bar",
  },
  'ai-button': {
    path: '',
    tags: ['ai'],
    internalOnly: false,
    stories: ['default'],
    description: 'Button to trigger AI actions',
  },
  'ai-chatbot-message': {
    path: '',
    tags: ['ai'],
    internalOnly: false,
    stories: [
      'default',
      'avatar-variant',
      'custom-content',
      'loading',
      'loading-phrases',
      'loading-style',
      'show-avatar',
    ],
    description:
      'AI chatbot message with avatar and loading state, for conversational threads',
  },
  'ai-modal': {
    path: '',
    tags: ['ai', 'modals'],
    internalOnly: false,
    stories: ['default', 'error-state'],
    description: 'Modal to display AI actions',
  },
  'ai-question-card': {
    path: '',
    tags: ['ai'],
    internalOnly: false,
    stories: ['default', 'disabled', 'question'],
    description:
      'Question card shown in an AI chat thread when the chatbot asks a question',
  },
  'ai-text-editor': {
    path: '',
    tags: ['ai'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Text editor with AI actions: proofread, improve, change tone and speech-to-text',
  },
  'ai-textarea': {
    path: '',
    tags: ['ai'],
    internalOnly: false,
    stories: [
      'default',
      'attachments',
      'busy',
      'button-text',
      'disabled',
      'hide-outer-glow',
      'hint',
      'keep-keyboard-open-on-valid-submit',
      'max-lines',
      'single-line',
      'skip-label',
      'toolbar-variants',
      'tooltip',
      'validation',
      'voice-input',
    ],
    description:
      'AI textarea with a send button and optional attachment and voice input buttons',
  },
  'ai-user-bubble': {
    path: '',
    tags: ['ai'],
    internalOnly: false,
    stories: ['default', 'attachments', 'attachments-only'],
    description:
      "Right-aligned blue bubble for the user's messages in a conversational AI thread.",
  },
  'auto-complete': {
    path: '',
    tags: ['controls'],
    internalOnly: false,
    stories: ['default', 'user-mention'],
    description:
      'Provides selectable suggestions triggered by the tagging directive keys',
  },
  'auto-link': {
    path: '',
    tags: ['text & links'],
    internalOnly: false,
    stories: ['default'],
    description: 'Directive to auto-link',
  },
  'best-practises': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: ['default'],
    description: "Banners which inform users what the do's and dont's are",
  },
  'bid-pattern-card': {
    path: '',
    tags: ['cards'],
    internalOnly: false,
    stories: ['default'],
    description:
      'The bid card pattern display the bid indormation in a single element.',
  },
  'bouncing-dots': {
    path: '',
    tags: ['loading', 'dots', 'typing', 'indicator'],
    internalOnly: true,
    stories: ['default', 'sizes'],
    description:
      'Three staggered bouncing dots — the "native chat" typing cue.',
  },
  'challenge-card': {
    path: '',
    tags: ['freelancer domain'],
    internalOnly: false,
    stories: ['default', 'compact', 'custom', 'loading'],
    description: 'Redesigned innovation challenge card',
  },
  'challenge-status-tag': {
    path: '',
    tags: ['freelancer domain'],
    internalOnly: false,
    stories: ['default'],
    description: 'Tags with challenge status',
  },
  'chat-button': {
    path: '',
    tags: ['controls'],
    internalOnly: false,
    stories: ['default', 'icon-only', 'responsive'],
    description:
      'Chat button with online status and unread count that opens a chatbox or inbox',
  },
  'comment-ui': {
    path: '',
    tags: ['structure'],
    internalOnly: false,
    stories: ['default', 'active', 'badges', 'header-icon'],
    description:
      'A comment displays user feedback and discussion thread on the platform.',
  },
  'completed-jobs': {
    path: '',
    tags: ['reputation'],
    internalOnly: true,
    stories: ['default', 'size'],
    description:
      'Is used to display the percent of completed jobs that the user have done',
  },
  confetti: {
    path: '',
    tags: [
      'popups / overlays',
      'confetti',
      'celebration',
      'animation',
      'party',
      'success',
    ],
    internalOnly: true,
    stories: ['default'],
    description:
      'Full-screen confetti celebration overlay, fired with `ConfettiService.burst()`',
  },
  'directory-item': {
    path: '',
    tags: ['navigation'],
    internalOnly: true,
    stories: ['default', 'alignment', 'arrow-colors', 'custom-content'],
    description:
      "Distinct bulleted lists of links, like the homepage's top job categories",
  },
  earnings: {
    path: '',
    tags: ['reputation'],
    internalOnly: true,
    stories: ['default', 'compact', 'flip-value', 'size'],
    description:
      "A widget that displays a user's earnings value, bound from 0 to 10",
  },
  'empty-state': {
    path: '',
    tags: ['other'],
    internalOnly: true,
    stories: ['default'],
    description: 'A basic pattern for consistent empty states.',
  },
  experience: {
    path: '',
    tags: ['structure'],
    internalOnly: false,
    stories: [
      'default',
      'background-color',
      'education',
      'linked-roles',
      'publications',
      'qualifications',
    ],
    description: 'Layout for Freelancer Experience',
  },
  'image-caption': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: ['default', 'color'],
    description:
      'Caption showing the cost, duration and owner of items showcased on landing pages',
  },
  'interactive-text': {
    path: '',
    tags: ['text & links'],
    internalOnly: false,
    stories: ['default', 'highlighted-text', 'max-lines'],
    description: 'Interactive text that supports emojis and links',
  },
  linkshim: {
    path: '',
    tags: ['text & links'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Checks clicked links against our internal lists before allowing a redirect',
  },
  'loading-avatar-row-card': {
    path: '',
    tags: ['loading', 'avatar', 'row', 'skeleton'],
    internalOnly: false,
    stories: ['default'],
    description:
      'A skeleton card of an avatar beside rows of loading text, e.g. for user cards',
  },
  'loading-text': {
    path: '',
    tags: ['loading'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Animated placeholder bars shown while text loads, to reduce layout jitter',
  },
  'loading-thread-item': {
    path: '',
    tags: ['loading', 'thread', 'messaging'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Skeleton placeholder for a thread list item while it loads from the network',
  },
  'moonshot-promo-banner': {
    path: '',
    tags: ['freelancer domain'],
    internalOnly: false,
    stories: ['default'],
    description: 'Promo banner for Freelancer Moonshot Innovation Challenges',
  },
  'newsfeed-system-messages': {
    path: '',
    tags: ['structure'],
    internalOnly: false,
    stories: ['default'],
    description: 'Structure for the items in newsfeed system messages',
  },
  'project-contest-card': {
    path: '',
    tags: ['cards'],
    internalOnly: false,
    stories: ['default'],
    description:
      "A card that displays a project's or contest's information in one element",
  },
  'radio-card': {
    path: '',
    tags: ['controls'],
    internalOnly: false,
    stories: [
      'default',
      'borders',
      'custom-content',
      'disable',
      'image-alignment',
      'show-radio',
    ],
    description:
      'Radio input with built-in layout subcomponents, for picking one option of a set',
  },
  'review-card': {
    path: '',
    tags: ['cards'],
    internalOnly: false,
    stories: [
      'default',
      'perspective',
      'reply',
      'services',
      'skills',
      'summary',
    ],
    description: 'Layout for Review card',
  },
  'review-count': {
    path: '',
    tags: ['reputation'],
    internalOnly: true,
    stories: ['default', 'size'],
    description:
      'Review count is used to display the amount of reviews the user has received',
  },
  'section-article': {
    path: '',
    tags: ['layouts (landing pages)'],
    internalOnly: true,
    stories: ['default', 'alignment', 'button', 'colors', 'sizes', 'title'],
    description:
      'Simple grid module for text, images and cards on marketing and content pages',
  },
  'section-case-study-carousel': {
    path: '',
    tags: ['layouts (landing pages)'],
    internalOnly: true,
    stories: ['default', 'caption', 'footer', 'header-detail', 'quote'],
    description: 'A carousel displaying case studies on landing pages.',
  },
  'section-companies': {
    path: '',
    tags: ['layouts (landing pages)'],
    internalOnly: true,
    stories: ['default', 'colors', 'custom-title', 'logos-list'],
    description: 'Used in landing pages to display company logos',
  },
  'section-feature': {
    path: '',
    tags: ['layouts (landing pages)'],
    internalOnly: true,
    stories: [
      'default',
      'alignment',
      'border-top',
      'dark-background',
      'full-width',
      'image-overflow',
      'overlay',
      'sizes',
    ],
    description:
      'Landing page section with a title, short intro and three highlighted features',
  },
  'section-gallery': {
    path: '',
    tags: ['layouts (landing pages)'],
    internalOnly: true,
    stories: ['default', 'dot-indicator', 'image-caption', 'thumbnails'],
    description:
      'A landing page image gallery with a main display and a thumbnail carousel',
  },
  'section-hero': {
    path: '',
    tags: ['layouts (landing pages)'],
    internalOnly: true,
    stories: [
      'default',
      'alignment',
      'colors',
      'content-width',
      'detail-text',
      'height',
      'image-detail',
      'video-background',
    ],
    description:
      'Hero header for showcasing key content on marketing and content-heavy pages',
  },
  'service-offering-carousel': {
    path: '',
    tags: ['structure'],
    internalOnly: false,
    stories: ['default', 'edit-mode'],
    description:
      'Carousel of service offerings and categories, with custom layout and actions',
  },
  'share-modal': {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: true,
    stories: ['default', 'card'],
    description: 'Modal for sharing a link through share buttons',
  },
  'showcase-card': {
    path: '',
    tags: ['cards'],
    internalOnly: false,
    stories: [
      'default',
      'aspect-ratio',
      'carousel',
      'clickable',
      'expandable-content',
      'not-image',
      'scale-on-hover',
      'showcase-card-variant',
    ],
    description: 'Tags: Cards',
  },
  skills: {
    path: '',
    tags: ['modals'],
    internalOnly: false,
    stories: ['default'],
    description: 'Skill selector feature for freelancers',
  },
  'upgrade-item': {
    path: '',
    tags: ['freelancer domain'],
    internalOnly: false,
    stories: ['default', 'free-upgrade', 'promo-price', 'variation'],
    description:
      'A pre-formatted upgrade with price, promo indicator, tags and description',
  },
  'upgrade-tag': {
    path: '',
    tags: ['tags'],
    internalOnly: true,
    stories: ['default', 'sizes', 'upgrade-types'],
    description: 'Tags for project/contest upgrades',
  },
  'user-feedback': {
    path: '',
    tags: ['modals'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Modal that prompts eligible users for feedback on a specific campaign',
  },
  'user-info': {
    path: '',
    tags: ['structure'],
    internalOnly: false,
    stories: ['default', 'user-avatar'],
    description: 'Layout for Users Info',
  },
  'user-rehire-card': {
    path: '',
    tags: ['cards'],
    internalOnly: false,
    stories: ['default'],
    description:
      "Dashboard rehire card showing a freelancer and the client's latest review",
  },
  'user-search-card': {
    path: '',
    tags: ['cards'],
    internalOnly: false,
    stories: ['default'],
    description:
      'The user search card pattern display the user information in a single element.',
  },
  username: {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: [
      'default',
      'badge',
      'colors',
      'compact',
      'flag',
      'sizes',
      'truncate-text',
      'with-link',
    ],
    description:
      "Shows a user's display name and username consistently across the site",
  },
  'video-record-input': {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: true,
    stories: [
      'default',
      'custom-content-while-recording',
      'custom-copies',
      'custom-subcontent',
      'face-filter',
    ],
    description:
      'A video button that opens the recording modal, with custom template content',
  },
  'video-record-modal': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: ['default'],
    description: 'Modal that wraps the video record component to record videos',
  },
  'worked-time': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: ['default', 'size'],
    description:
      'Widget showing the hours a user has worked on similar projects',
  },
};
